module.exports = __webpack_public_path__ + "static/media/unlink-outline.e077c10f.svg";